export const ArrowBack = () => (
  <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26 12H3M13 1L2 12L13 23" stroke="currentColor" strokeWidth="2" />
  </svg>
)
